import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import classNames from "classnames";

import FetchOnSubmit from "components/Library/FetchOnSubmit";
import NewsletterPromoImage from "cards/components/NewsletterPromoImage";
import NewsletterPromoSuccess from "cards/components/NewsletterPromoSuccess";
import NewsletterSubscribeForm from "components/Library/NewsletterSubscribeForm";
import { FETCH_STATUS } from "config/constants";

import styles from "./NewsletterPromo.css";

export default class NewsletterPromo extends React.Component {
  render() {
    return (
      <div className={styles.root}>
        <NewsletterPromoImage src={this.props.image} />
        <div className={styles.card}>
          <FetchOnSubmit method="POST" url="/readers/unauth-sub/">
            {({ status, error, submit, reset }) => {
              return (
                <React.Fragment>
                  <div aria-live="polite" role="status">
                    {status === FETCH_STATUS.SUCCESS && (
                      <div className={styles.successOverlay}>
                        <NewsletterPromoSuccess />
                      </div>
                    )}
                  </div>
                  <div aria-hidden={status === FETCH_STATUS.SUCCESS}>
                    <h4>
                      <Link
                        to={this.props.link}
                        className={classNames(
                          styles.header,
                          "gtm-nl-promo-title"
                        )}
                      >
                        {this.props.title}
                      </Link>
                    </h4>
                    <p className={styles.paragraph}>{this.props.content}</p>
                    <NewsletterSubscribeForm
                      list={this.props.list}
                      formClassName="gtm-newsletter-promo-in-stream"
                      userVars={{ campaign: "stream_cta_direct_email_input" }}
                      status={status}
                      submit={submit}
                      reset={reset}
                      error={error}
                    />
                  </div>
                </React.Fragment>
              );
            }}
          </FetchOnSubmit>
        </div>
      </div>
    );
  }
}

NewsletterPromo.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  list: PropTypes.string.isRequired,
};
